import { render } from "./showcase.vue?vue&type=template&id=e1633628&scoped=true"
import script from "./showcase.vue?vue&type=script&lang=js"
export * from "./showcase.vue?vue&type=script&lang=js"

import "./showcase.vue?vue&type=style&index=0&id=e1633628&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1633628"]])

export default __exports__